import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import axios from 'axios'
import Form from '../components/Membership/Form'
import Docs from '../components/Membership/Docs'
import LoaderDots from '../components/loaderDots'
import { initGA, event } from '../components/analytics'

import i18n from '../i18n'

import CurrencyChecker from '../components/currencyChecker'

class Membership extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formInputs: {
        membershipType: undefined,
        birth: { day: undefined, month: undefined, year: undefined },
        belt: { label: undefined, value: undefined },
        country: { label: undefined, value: undefined },
      },
      ageOnYear: undefined,
      currentAge: undefined,
      fee: undefined,
      currency: undefined,
      loading: false,
      docs: [],
    }
  }

  componentDidMount() {
    initGA()
  }

  ageCalc() {
    const { day, month, year } = this.state.formInputs.birth
    let age = { onYear: undefined, current: undefined }

    if (!day || month === undefined || !year) return age

    let today = new Date()

    let currentYear = today.getFullYear()
    let currentMonth = today.getMonth()
    let currentDay = today.getDay()

    let birthDateYear = parseInt(year)
    let birthDateMonth = parseInt(month)
    let birthDateDay = parseInt(day)

    age.onYear = currentYear - birthDateYear

    if (currentMonth > birthDateMonth) age.current = age.onYear
    if (currentMonth < birthDateMonth) age.current = age.onYear - 1
    if (currentMonth == birthDateMonth) {
      if (currentDay >= birthDateDay) {
        age.current = age.onYear
      } else {
        age.current = age.onYear - 1
      }
    }

    return age
  }

  async fetchDocuments() {
    const { birth, belt, country } = this.state.formInputs

    const birthDate = `${birth.year}-${birth.month + 1}-${birth.day}`

    const params = {
      date_of_birth: birthDate,
      belt: belt.value,
      country_code: country.value,
    }

    await axios
      .get('/api/v1/athletes/membership_docs.json', {
        params: params,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      .then((response) => {
        this.setState({
          docs: response.data.data.attributes.baseDocuments,
          currency: CurrencyChecker(response.data.data.attributes.pricing.currency),
          fee: response.data.data.attributes.pricing.priceFinal,
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  validateForm() {
    const { membershipType, birth, belt, country } = this.state.formInputs

    if (!membershipType) return false
    if (!birth.day || birth.month === undefined || !birth.year) return false
    if (!belt.value) return false
    if (!country.value) return false

    return true
  }

  async handleSubmitEvent() {
    this.setState({ loading: true })

    if (await !this.validateForm()) {
      this.setState({ loading: false })
      return null
    }

    await this.fetchDocuments()
    this.setState({ loading: false })
  }

  onBirthDateChange(event) {
    let newState = Object.assign({}, this.state)
    newState['formInputs']['birth'][event.target.name] = parseInt(
      event.target.value
    )
    this.setState(newState, () =>
      this.setState(() => {
        let age = this.ageCalc()
        return { ageOnYear: age.onYear, currentAge: age.current }
      })
    )
  }

  updateInputState(e) {
    let newState = Object.assign({}, this.state)
    newState['formInputs'][e.target.name] = e.target.value

    this.setState(newState)
    this.sendGAEvent(e.target)
  }

  sendGAEvent(target) {
    const eventsCategory = 'Membership'
    switch (target.name) {
      case 'membershipType':
        event(eventsCategory, 'Membership type choose', target.value)
        break
      case 'belt':
        event(eventsCategory, 'Belt choose', target.value.label)
        break
      case 'country':
        event(eventsCategory, 'Country choose', target.value.label)
        break
      default:
        break
    }
  }

  componentChooser() {
    if (this.state.loading) return <LoaderDots />

    if (this.state.docs.length == 0) {
      return (
        <Form
          handleSubmitEvent={this.handleSubmitEvent.bind(this)}
          updateInputState={this.updateInputState.bind(this)}
          onBirthDateChange={this.onBirthDateChange.bind(this)}
          formInputs={this.state.formInputs}
          ageOnYear={this.state.ageOnYear}
          currentAge={this.state.currentAge}
          i18n={i18n}
        />
      )
    } else {
      return (
        <Docs
          docs={this.state.docs}
          choosedOptions={this.state.formInputs}
          currency={this.state.currency}
          fee={this.state.fee}
          ageOnYear={this.state.ageOnYear}
          currentAge={this.state.currentAge}
          i18n={i18n}
        />
      )
    }
  }

  render() {
    return <div className="col-sm-12">{this.componentChooser()}</div>
  }
}

Membership.propTypes = {
  loading: PropTypes.bool,
  docs: PropTypes.instanceOf(Array),
  fee: PropTypes.number,
  currency: PropTypes.string,
  ageOnYear: PropTypes.number,
  currentAge: PropTypes.number,
  formInputs: PropTypes.shape({
    membershipType: PropTypes.string,
    birth: PropTypes.shape({
      day: PropTypes.number,
      month: PropTypes.number,
      year: PropTypes.number,
    }),
    belt: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    country: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  }),
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<Membership />, document.querySelector('#membership-page'))
})
